import { CONCIERGE_ATTRIBUTION_CART_ATTRIBUTE_KEY } from "@redotech/redo-model/shopify/cart";
import { ExtensionShopifyClient } from "@redotech/shopify-client/ajax";

const CONCIERGE_CONVERSATION_IDS_STORAGE_KEY = "redoConciergeConversationIds";
const EXPIRY_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

interface ConversationIdWithExpiry {
  conversationId: string;
  expiresAt: number;
}

export async function addConciergeAttributionCartAttribute(
  extensionShopifyClient: ExtensionShopifyClient,
) {
  const conciergeConversationIds = getConciergeConversationIdsFromStorage();
  if (!conciergeConversationIds || conciergeConversationIds.length === 0) {
    return;
  }

  const conversationIdsObj = {
    conciergeConversationIds: conciergeConversationIds || [],
  };

  await extensionShopifyClient.updateCartAttribute({
    attributes: [
      {
        key: CONCIERGE_ATTRIBUTION_CART_ATTRIBUTE_KEY,
        value: JSON.stringify(conversationIdsObj),
      },
    ],
  });
}

export function getConciergeConversationIdsFromStorage(): string[] | null {
  try {
    const stored = localStorage.getItem(CONCIERGE_CONVERSATION_IDS_STORAGE_KEY);
    if (!stored) {
      return null;
    }

    const conversationIdsWithExpiry: ConversationIdWithExpiry[] =
      JSON.parse(stored);
    const now = Date.now();

    const validConversationIds = conversationIdsWithExpiry
      .filter((item) => item.expiresAt > now)
      .map((item) => item.conversationId);

    return validConversationIds.length > 0 ? validConversationIds : null;
  } catch (error) {
    return null;
  }
}

export function addConciergeConversationIdToStorage(
  conversationId: string,
): void {
  const stored = localStorage.getItem(CONCIERGE_CONVERSATION_IDS_STORAGE_KEY);
  let conversationIdsWithExpiry: ConversationIdWithExpiry[] = [];

  if (stored) {
    try {
      conversationIdsWithExpiry = JSON.parse(stored);
      if (!Array.isArray(conversationIdsWithExpiry)) {
        conversationIdsWithExpiry = [];
      }
    } catch (parseError) {
      conversationIdsWithExpiry = [];
    }
  }

  const now = Date.now();

  conversationIdsWithExpiry = conversationIdsWithExpiry.filter(
    (item) => item.expiresAt > now && item.conversationId !== conversationId,
  );

  conversationIdsWithExpiry.push({
    conversationId,
    expiresAt: now + EXPIRY_MS,
  });

  localStorage.setItem(
    CONCIERGE_CONVERSATION_IDS_STORAGE_KEY,
    JSON.stringify(conversationIdsWithExpiry),
  );
}
